import * as React from 'react';
import { Form } from './components/Form';

export const Login = ({ history }) => {

  sessionStorage.clear();

  return(
    <Form
      history={history}
      urlLogin={process.env.API_LOGIN}
      urlRecoverPassword={process.env.API_RECOVER_PASSWORD}
    />
  );
};

